const inviteSignup = {
  toastr: 'Invitation sent',
  toastr1: 'The invitation has been sent successfully'
};

export default inviteSignup;
